<template >
    <div>
        <b-carousel
            id="carousel-1"
            v-model="slide"
            :interval="4000"
            controls
            indicators
            background="#ababab"
            img-width="1024"
            img-height="480"
            style="text-shadow: 1px 1px 2px #333"
            @sliding-start="onSlideStart"
            @sliding-end="onSlideEnd"
        >
            <!-- Slides with img slot -->
            <!-- Note the classes .d-block and .img-fluid to prevent browser default image alignment -->
            <b-carousel-slide v-for="item in listData" v-bind:key="item.id">
                <template #img>
                    <span v-on:click="redirectToDetail(item)">
                        <div class="h-100 w-100" :style="item.images.length > 0 ? { background: 'url(' + createImageURL(item.images[0].full_original_url) + ') no-repeat', backgroundSize: 'cover'} : null">
                        </div>
                    </span>
                </template>
            </b-carousel-slide>
        </b-carousel>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { RootAPI } from '../api/index';

export default {
    layout: 'main',
    name: 'Banner',
    props: {
        isGoToDetail: {
            type: Boolean,
            required: true,
        },
        storeCode: {
            type: String,
            required: true,
        },
        brandCode: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            slide: 0,
            sliding: null,
        };
    },
    computed: {
        ...mapGetters({
            listData: 'banner/banners',
        }),
    },
    async mounted() {
        var data = {};
        if (this.storeCode != null && this.storeCode != '') {
            data.store_code = this.storeCode;
        }
        if (this.brandCode != null && this.brandCode != '') {
            data.brand_cd = this.brandCode;
        }
        await this.$store.dispatch('banner/getListBanner', data);
    },
    methods: {
        onSlideStart(slide) {
            this.sliding = true;
        },
        onSlideEnd(slide) {
            this.sliding = false;
        },
        redirectToDetail(banner) {
            if (banner.product_code != null && banner.product_code != 'null') {
                const [categoryCode, classCode, productCode] =
                    banner.product_code.split('-');
                if (this.isGoToDetail) {
                    this.$router.push({
                        path: '/detail',
                        query: { product_code: productCode },
                    });
                }
                return;
            } else {
                return window.open(banner.redirect_url);
            }
        },
        createImageURL(baseURL) {
            let imageURLTmp = baseURL.substring(1, baseURL.length);
            return RootAPI + 'v2/' + imageURLTmp;
        },
    },
};
</script>